import { NavigationRouteContext } from '@react-navigation/native';
import React, { useContext, useEffect, useState } from 'react';

import ActivityIndicatorLoading from '@components/shared/ActivityIndicatorLoading';
import { useWebDrawer } from '@components/Web/Drawer/WebDrawerContext';
import { useProjectFromQuery } from '@hooks/useProjectFromQuery';

import { FormValues, ProjectFormStack } from './ProjectFormStack';

type RouteParams = {
  teamId?: string;
  teamUUId?: string;
};

interface CreateProjectProps {
  isShortModal?: boolean;
  externalNavigate?: any;
  // TA-10949 #24: threaded down to ProjectForm — see its own doc comment.
  attemptCloseRef?: React.MutableRefObject<(() => void) | null>;
}

const CreateProject: React.FC<CreateProjectProps> = ({
  isShortModal,
  externalNavigate,
  attemptCloseRef,
}) => {
  const route = useContext(NavigationRouteContext);
  const routeParams = route?.params as RouteParams | undefined;
  const routeTeamId = routeParams?.teamId;
  const routeTeamUUId = routeParams?.teamUUId;
  const { editProjectUUId } = useWebDrawer();
  const [projectId, setProjectId] = useState<string>();

  const { project, loading } = useProjectFromQuery({
    projectUUId: editProjectUUId,
  });

  useEffect(() => {
    setProjectId(project?.id);
  }, [project]);

  if (editProjectUUId != '') {
    if (!project || loading) return <ActivityIndicatorLoading />;
    const initialMembers = project.members.map((m) => {
      return {
        ...m.user,
        role: m.role,
      };
    });

    const initialValues: FormValues = {
      location: project.address
        ? {
            address: project.address,
            latitude: project?.latitude || 0,
            longitude: project?.longitude || 0,
          }
        : null,
      color: project.color || 'purple',
      icon: project.icon || 'IconStart22',
      description: project.description || '',
      id: project.id,
      uuid: project.uuid,
      name: project.name || '',
      teamId: project.team?.id || '',
      teamUUId: project.team?.uuid || '',
      users: (initialMembers || []) as any,
      projectMembers: [],
      currentTeam: project.team as any,
    };

    return (
      <ProjectFormStack
        initialValues={initialValues}
        projectId={projectId}
        isShortModal={isShortModal}
        externalNavigate={externalNavigate}
        attemptCloseRef={attemptCloseRef}
      />
    );
  } else {
    const initialValues: FormValues = {
      id: undefined,
      uuid: undefined,
      name: '',
      location: null,
      description: '',
      teamId: routeTeamId ?? '',
      teamUUId: routeTeamUUId ?? '',
      users: [],
      projectMembers: [],
      color: 'purple',
      icon: 'IconStart22',
      currentTeam: null,
    };
    return (
      <ProjectFormStack
        initialValues={initialValues}
        isShortModal={isShortModal}
        externalNavigate={externalNavigate}
        attemptCloseRef={attemptCloseRef}
      />
    );
  }
};

export default CreateProject;
